import React from 'react';

import useStyles from './CarouselWrapper.styles';

type Props = {
  children: React.ReactNode;
  noMargin?: boolean;
  noTopPadding?: boolean;
  hideScrollbar?: boolean;
  leftMargin?: number;
};

const CarouselWrapper: React.FC<Props> = ({ children, noMargin, noTopPadding, leftMargin, hideScrollbar }) => {
  const styles = useStyles({ noMargin: !!noMargin, noTopPadding: !!noTopPadding, leftMargin, hideScrollbar });
  return (
    <div className={styles.externalWrapper}>
      <div className={styles.internalWrapper}>
        <div className={styles.scrollableElement}>{children}</div>
      </div>
    </div>
  );
};

export default CarouselWrapper;
